import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CondominiumService, Condominium } from '../../services/condominium.service';

@Component({
    selector: 'app-condominium-layout',
    templateUrl: './condominium-layout.component.html',
    styleUrls: ['./condominium-layout.component.sass'],
    standalone: false
})
export class CondominiumLayoutComponent implements OnInit {
  condominium: Condominium | null = null;

  constructor(
    private route: ActivatedRoute,
    private condominiumService: CondominiumService
  ) { }

  ngOnInit(): void {
    const condominiumId = this.route.snapshot.paramMap.get('id');
    if (condominiumId && !isNaN(Number(condominiumId))) {
      // Carregar os dados do condomínio se necessário
      this.condominiumService.getCondominiumDetails(Number(condominiumId)).subscribe({
        next: (condominium) => {
          this.condominium = condominium;
        },
        error: (error) => {
          console.error('Error loading condominium details:', error);
        }
      });
    }
  }

}
